import { render } from "./ImportGuid.vue?vue&type=template&id=496a7f18&scoped=true&ts=true"
import script from "./importGuidHelper.ts?vue&type=script&lang=ts"
export * from "./importGuidHelper.ts?vue&type=script&lang=ts"

import "./ImportGuid.vue?vue&type=style&index=0&id=496a7f18&scoped=true&lang=scss"

import exportComponent from "D:\\softwhere\\tools\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496a7f18"]])

export default __exports__